import React from 'react';
import { AboutArchived } from './AboutArchived';

export const ArchiveOverview: React.FC = () => {
  return (
    <div className="space-y-6">
      <AboutArchived />
    </div>
  );
};


